<template>
    <AppModal :name="name" :beforeOpen="beforeOpen" :beforeClose="beforeClose">

        <template slot="header">
            Add users
        </template>

        <template slot="content">

            <div v-if="users.length === 0" class="text-muted mb-5">
                No data
            </div>
            <div v-else class="mb-4">
                <div v-if="users.length > 1" class="my-2 text-left">
                    <div class="custom-control custom-checkbox">
                        <input v-model="selectAll"
                               class="custom-control-input mt-1"
                               type="checkbox"
                               id="select-all">
                        <label class="custom-control-label pt-1" for="select-all">
                            Select all
                        </label>
                    </div>
                </div>
                <div v-for="user in users" :key="user.uuid"
                     @click="onChangeSelection(user)"
                     class="user-row mb-1"
                     :class="{ active: selectedUsers.findIndex(el => el.uuid === user.uuid) !== -1 }">
                    <div class="text-left">
                        <AppAssignUser :uuid="user.uuid" readonly/>
                        <span class="ml-2">
                            {{ user.firstName + ' ' + user.lastName }}
                        </span>
                    </div>
                </div>
            </div>

        </template>

        <template slot="actions">
            <div class="row justify-content-end">
                <button @click="$modal.hide(name)" class="btn btn-link mt-1">Cancel</button>
                <button @click="add"
                        v-loading.btn="isUsersAdding"
                        class="btn btn-primary mt-1 mr-2"
                        style="width: 100px">
                    Add
                </button>
            </div>
        </template>
    </AppModal>
</template>

<script>

export default {
    name: 'DtAddUsers',
    props: {
        name: {
            type: String,
            required: true
        },
        users: {
            type: Array,
            required: true
        },
        onAdd: {
            type: Function
        }
    },
    data() {
        return {
            selectedUsers: [],

            isUsersAdding: false,
            selectAll: false
        }
    },
    methods: {
        beforeOpen({params}) {
        },

        beforeClose() {
            this.selectedUsers = []
        },

        async add() {
            if (this.selectedUsers.length !== 0) {
                this.isUsersAdding = true
                await this.onAdd(this.selectedUsers)
                this.isUsersAdding = false
                this.$modal.hide(this.name)
            } else {
                this.$snackbar.show({type: 'INFO', text: `Select user`})
            }
        },

        onChangeSelection(user) {
            const idx = this.selectedUsers.findIndex(el => el.uuid === user.uuid)
            if (idx === -1) {
                this.$set(this.selectedUsers, this.selectedUsers.length, user)
            } else {
                this.$delete(this.selectedUsers, idx)
            }
        }
    },
    watch: {
        selectAll(val) {
            if (val) {
                this.selectedUsers = _.cloneDeep(this.users)
            } else {
                this.selectedUsers = []
            }
        }
    }
}
</script>

<style scoped lang="scss">
    .user-row {
        padding: 10px 20px;
        border: 1px solid $color-grey-light;

        &.active, &:hover {
            border-radius: 5px;
            cursor: pointer;
            background: $color-purple-soft;
        }
    }

    .user-row {
        border-top: 1px solid rgba(0, 0, 0, .1);
        border-left: none;
        border-right: none;
        border-bottom: none;
    }

    .user-row:first-child {
        border-top: none !important;
    }
</style>
